import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { shopifyActions } from 'store';
import { ShopifyMap } from './fragments/shopifyMap';
import { RightDrawer, shopifyOrderBody, shopifyOrderHead } from './fragments';
import { SavePage } from 'utils';
import { ProductMapModal } from './fragments/productMapModal';
import { Box, Tab, Tabs } from '@mui/material';
import { buttonsStyle } from '../amazon/fragments';
import { singleShopifyTabs } from './fragments/constants';
import { PriceRules } from '../../components';

function tabProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const SingleShopifyStore = () => {
    const [showSelected, setShowSelected] = useState('');
    const { id } = useParams();
    const dispatch = useDispatch();
    const { shopifyOrders, setUpSingle } = useSelector(state => state.shopify);
    const history = useHistory();
    const classes = buttonsStyle();
    const info = history?.location?.state;


    const setupRequestParams = () => {
        const filteredInfo = {
            ...info,
            storeSetupId: id,
            limit: 100,
            skip: info?.skip ? info?.skip : 0,
        };
        delete filteredInfo?.page;
        delete filteredInfo?.singleStore;

        return filteredInfo;
    };

    useEffect(() => {
        dispatch(shopifyActions.getShopifyOrders(setupRequestParams()));
    }, [info?.page, info?.skip, info?.limit]);


    useEffect(() => {
        dispatch(shopifyActions.getShopifySingleSetup(id));
    }, [dispatch]);


    useEffect(() => {
        if (setUpSingle) {
            history.push({ state: { ...info, singleStore: setUpSingle } });
        }
    }, [setUpSingle]);

    const renderTableValues = {
        head: shopifyOrderHead,
        body: shopifyOrderBody,
        actionType: 'GET_SHOPIFY_ORDERS',
        list: shopifyOrders?.orders,
        count: shopifyOrders?.count,
    };


    const handleSearchReq = () => {
        SavePage(history);
    };

    const handleChangeTabs = (event, newValue) => {
        SavePage(history, info, { tab: newValue });
        setShowSelected('');
    };

    const renderParams = () => {
        const filteredInfo = {
            ...info,
        };
        delete filteredInfo.page;
        delete filteredInfo.tab;

        return filteredInfo;
    };

    const handleOpenProductMap = (item) => {
        setShowSelected(item);
        dispatch(shopifyActions.orderProductMap(item?.shopifySKU));
    };


    return (
        <div>
            <div className='title-buttons-wrapper'>
                <Box className='tabBox'>
                    <Tabs
                        className={classes.buttonsTab} value={info?.tab ? info?.tab : singleShopifyTabs.ORDERS}
                        onChange={handleChangeTabs}
                        aria-label='basic tabs example'
                    >
                        <Tab className='tab' label='Orders' value={singleShopifyTabs.ORDERS} {...tabProps(0)} />
                        <Tab className='tab' label='Price Rules'
                             value={singleShopifyTabs.PRICE_RULES} {...tabProps(1)} />
                    </Tabs>
                </Box>

                {(!info?.tab || info?.tab === singleShopifyTabs.ORDERS) &&
                    <div className='buttons-wrapper' style={{ justifyContent: 'flex-end' }}>
                        <RightDrawer
                            item={setUpSingle}
                        />
                    </div>
                }
            </div>

            {(!info?.tab || info?.tab === singleShopifyTabs.ORDERS) &&
                <div style={{ display: 'flex' }}>
                    <ShopifyMap
                        renderParams={renderParams}
                        handleOpen={handleOpenProductMap}
                        head={renderTableValues?.head}
                        body={renderTableValues?.body}
                        loadingType={'GET_SHOPIFY_ORDERS'}
                        type={''}
                        list={renderTableValues?.list}
                        listCount={renderTableValues?.count}
                        handleSearchReq={handleSearchReq}
                    />
                    {showSelected && <ProductMapModal handleClose={() => setShowSelected(null)} />}
                </div>
            }

            {info?.tab === singleShopifyTabs.PRICE_RULES &&
                <PriceRules
                    store='SHOPIFY'
                    actionType={'EDIT_SHOPIFY_PRICE_RULES'}
                    values={setUpSingle?.priceSettings}
                    singleId={id}
                    setupRequestParams={setupRequestParams()}
                />
            }
        </div>
    );
};

